import React from 'react';
import {
  Row,
  Col,
  Table,
  Overlay,
  Popover,
  Alert
} from "react-bootstrap";


import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import { StatsCard } from "components/Card/StatsCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import SaleOrderSelect from 'components/SaleOrderSelect/SaleOrderSelect';
import FirstQuotaAndReserveSelect from 'components/FirstQuotaAndReserveSelect/FirstQuotaAndReserveSelect';

import { connect } from 'react-redux';

import {
  fetchQuotasToPay,
  updateQuotaSelection,
  updateSaleOrderAtToPay,
  updateSelectedQuotaId,
  updateDraftSaleOrderPaymentType
} from 'reducers/quotastopay/quotastopayActions'
import { showWarningMessage } from 'reducers/application/applicationActions'
import { fetchStatusSaleOrderInProgressPromise } from 'reducers/saleorders/saleordersActions'

import { timestampToFormattedDate } from 'utils/Date/DateUtils';
import { formatToDecimal, roundNumber } from 'utils/Number/NumberUtils';

import OnlinePaymentAlert from "components/OnlinePaymentAlert/OnlinePaymentAlert";

import { SALEORDER_STATUS_DRAFT, SALEORDER_STATUS_CONFIRMED } from "constants/saleOrderStatusConst"

import {
  SALEORDER_PAYABLE
} from "constants/saleOrderTypeConst"

import { NONE } from 'constants/draftSaleOrderPaymentTypeConst';
import { RESERVE, COMPLETE_QUOTA } from '../../constants/draftSaleOrderPaymentTypeConst';

class SelectSaleOrderStep extends React.Component {
  constructor(props) {
    super(props);
    this.initState();
    this.loadQuotasToPay = this.loadQuotasToPay.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.updateDraftSaleOrderPaymentType = this.updateDraftSaleOrderPaymentType.bind(this);
  }

  initState() {
    this.state = {
      show: false,
      target: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.saleOrderInProgressStatus !== this.props.saleOrderInProgressStatus) {
      if (nextProps.saleOrderInProgressStatus.value == true) {
        this.onlinePaymentAlert.showOnlinePaymentInProgressAlert();
      }
    }
  }

  isValidated() {
    return this.isValid();
  }

  isValid() {
    if (!this.validate()) return false;

    return new Promise((resolve, reject) => {
      this.props.fetchStatusSaleOrderInProgressPromise(this.props.saleOrder.id, resolve, reject);
    });

  }

  validate() {
    if (!this.isSaleOrderSelected()) {
      this.props.showWarningMessage("Por favor seleccionar un lote a pagar");
      return false;
    }
    if (this.isSomeQuotaSelected() == false) {
      if (this.props.saleOrder.status === SALEORDER_STATUS_DRAFT) {
        this.props.showWarningMessage("Por favor seleccionar Pago");
      } else {
        this.props.showWarningMessage("Por favor seleccionar al menos una quota");
      }
      return false;
    }
    return true;
  }

  isSaleOrderSelected() {
    console.log("Select value", this.props.saleOrder.id);
    return this.props.saleOrder.id != 0;
  }

  isSomeQuotaSelected() {
    for (let index in this.props.quotas) {
      if (this.props.quotas[index].selected == true) {
        return true;
      }
    }
    return false;
  }

  loadQuotasToPay(saleOrder) {
    if (saleOrder.id == 0) {
      this.props.updateSelectedQuotaId(0);
    }
    this.props.updateSaleOrderAtToPay(saleOrder);
    this.fetchQuotas(saleOrder);
    this.props.updateDraftSaleOrderPaymentType(NONE, 0);
  }

  fetchQuotas(saleOrder) {
    this.setState({ target: null, show: false });

    let promise = new Promise((resolve, reject) => {
      this.props.fetchQuotasToPay(saleOrder.id, resolve);
    });

    promise.then(() => {
      if (this.props.selectedQuotaId != 0) {
        document.getElementById(this.props.selectedQuotaId).click();
      }
    });
  }

  handleCheckChange = (key) => (evt) => {
    let quotaSelected = this.props.quotas[key];
    console.log("Quota selected", quotaSelected);
    this.props.updateQuotaSelection(quotaSelected.id);
    console.log("target", evt.target);
    this.setState({ target: evt.target, show: true });
  }

  handleNext() {
    if (!this.validate()) return;

    let promise = new Promise((resolve, reject) => {
      this.props.fetchStatusSaleOrderInProgressPromise(this.props.saleOrder.id, resolve, reject);
    });

    promise.then(() => {
      this.props.jumpToStep(1);
    }, () => {

    });
  }

  updateDraftSaleOrderPaymentType(paymentType) {
    this.props.updateDraftSaleOrderPaymentType(paymentType, this.props.saleOrder.id);
  }

  render() {
    return (
      <div className="wizard-step">
        <OnlinePaymentAlert ref={instance => { this.onlinePaymentAlert = instance; }} />
        <Row>
          <Col md={10} mdOffset={1}>
            <div>
              <SaleOrderSelect
                onRef={ref => (this.saleOrderSelect = ref)}
                loadParentContent={this.loadQuotasToPay}
                firstItemLabel="Seleccionar Lote"
                saleOrder={this.props.saleOrder}
                saleOrderType={SALEORDER_PAYABLE}
              />
              {this.props.saleOrder.status === SALEORDER_STATUS_DRAFT &&
                <FirstQuotaAndReserveSelect
                  paymentType={this.props.draftSaleOrderPaymentType}
                  updateDraftSaleOrderPaymentType={this.updateDraftSaleOrderPaymentType}
                />
              }
            </div>
            {this.props.saleOrder.status === SALEORDER_STATUS_CONFIRMED &&
              <Alert bsStyle="warning">
                <span>Por favor apersonarse a nuestras oficinas para realizar la firma de contrato correspondiente. Si ya realizó la firma de contrato refresque la página.</span>
              </Alert>
            }
          </Col>
        </Row>
        <Row>
          <Col md={4} >
            <div className="card-total__topay">
              <StatsCard
                bigIcon={<i className="pe-7s-cash text-success" />}
                statsText="Total a pagar"
                statsValue={formatToDecimal(roundNumber(this.props.totalToPay, 2)) + " $"}
              />
            </div>
          </Col>
          <Col md={8} >
            <Table striped responsive>
              <thead>
                <tr>
                  <th>Descripción</th>
                  <th>Fecha a pagar</th>
                  <th className="text-right">Monto($)</th>
                  <th className="text-right">Saldo Por Pagar($)</th>
                  <th className="text-right">Saldo Futuro($)</th>
                  {this.props.saleOrder.status !== SALEORDER_STATUS_DRAFT && <th></th>}
                </tr>
              </thead>
              <tbody>
                {this.props.quotas.map((quota, key) => {
                  let color = "";
                  if (quota.status === "PAGADA") {
                    color = "success";
                  } else {
                    if (quota.overdue == true) {
                      color = "danger"
                    }
                  }
                  return (
                    <tr key={key} className={color}>
                      <td>{quota.description}</td>
                      <td>{timestampToFormattedDate(quota.dueDate)}</td>
                      <td className="text-right">{formatToDecimal(quota.amount)}</td>
                      <td className="text-right">{formatToDecimal(quota.currentBalance)}</td>
                      <td className="text-right">{formatToDecimal(quota.futureBalance)}</td>
                      {this.props.saleOrder.status !== SALEORDER_STATUS_DRAFT && <td>
                        <Checkbox
                          bsclass="selected-saleorder-step__checkbox"
                          number={quota.id}
                          onClick={this.handleCheckChange(key)}
                          checked={quota.selected}
                          label=""
                        />
                      </td>
                      }
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Overlay
              show={this.state.show}
              target={this.state.target}
              onHide={() => console.log('hide')}
              placement="right"
              containerPadding={20}
              rootClose={true}
            >
              <Popover id="popover-contained" title="">
                <Button
                  bsStyle="info"
                  fill
                  wd
                  onClick={this.handleNext}
                >
                  Pagar
                  </Button>
              </Popover>
            </Overlay>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  quotas: state.quotasToPay.quotas,
  totalToPay: state.quotasToPay.totalToPay,
  makeRequestQuotas: state.quotasToPay.makeRequestQuotas,
  saleOrder: state.quotasToPay.saleOrder,
  selectedQuotaId: state.quotasToPay.selectedQuotaId,
  saleOrderInProgressStatus: state.saleorders.saleOrderInProgressStatus,
  draftSaleOrderPaymentType: state.quotasToPay.draftSaleOrderPaymentType
});

//export default connect(mapStateToProps, { fetchQuotasToPay, updateQuotaSelection })(SelectSaleOrderStep);
export default connect(mapStateToProps,
  {
    fetchQuotasToPay,
    updateQuotaSelection,
    showWarningMessage,
    updateSaleOrderAtToPay,
    updateSelectedQuotaId,
    fetchStatusSaleOrderInProgressPromise,
    updateDraftSaleOrderPaymentType
  },
  null,
  { withRef: true })(SelectSaleOrderStep);


// WEBPACK FOOTER //
// ./src/components/PaymentWizard/SelectSaleOrderStep.jsx